import React from 'react';
import FriendsManager from '../../FriendsManager';

export default function FriendsSection({
    onStorefrontChanged,
    wrapperElement = 'section',
}) {
    const Wrapper = wrapperElement;

    return (
        <Wrapper>
            <div className="sfm-section-header">
                <h2>Mayhem Friends</h2>
                <p>
                    Recommend up to five other Mayhem storefronts at the bottom of your
                    landing page.
                </p>
            </div>
            <FriendsManager onChanged={onStorefrontChanged} />
        </Wrapper>
    );
}
